module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('box-info', {
    staticClass: "ls-xs-margin-bottom ls-display-none-xs",
    class: {
      'suggested-plan': _vm.chosenPlan.suggested
    }
  }, [(_vm.chosenPlan.suggested) ? _c('div', {
    staticClass: "ribbon ribbon-top-right",
    slot: "suggested"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('subscribe.attributes.suggested')))])]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "ls-text-xl",
    slot: "title"
  }, [_vm._v(_vm._s(_vm.chosenPlan.name))]), _vm._v(" "), _c('h3', {
    slot: "value"
  }, [_vm._v("R$ "), _c('span', [_vm._v(_vm._s(_vm.money.parseViewValue(_vm.chosenPlan.price)))]), _c('small', [_vm._v("/ " + _vm._s(_vm.$t('subscribe.attributes.monthly')))])]), _vm._v(" "), _c('p', {
    staticClass: "plan-description",
    slot: "description"
  }, [_vm._v(_vm._s(_vm.chosenPlan.description))]), _vm._v(" "), _c('footer', {
    staticClass: "ls-box-footer",
    slot: "footer"
  }, [(_vm.formsSubmitted) ? _c('div', [_c('button', {
    staticClass: "btn ls-full-width ls-text-lg",
    class: {
      'btn-act is-active': _vm.formsSubmitted
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v(_vm._s(_vm.$t('subscribe.buttons.hire')))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-sm ls-display-none-xs"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$parent.backToSignaturePlans($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('subscribe.attributes.choose_another_plan')))])]), _vm._v(" "), (_vm.formsSubmitted) ? _c('button', {
    staticClass: "btn btn-act next btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v(_vm._s(_vm.$t('subscribe.buttons.hire')) + " "), _vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4157afcf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/subscribe/components/BoxCheckout.vue
// module id = 762
// module chunks = 1